// import ProfileIcon from '../assets/images/profile/idpic.jpg';

const FakeAgents = [
  {
    address: '',
    city: '',
    country: 'BJ',
    email: 'gerlix@right-com.com',
    firstname: 'Gerlix',
    full_rights: [
      {
        code: 'USA',
        group: 'Simple User',
        name: 'RightCare Simple User',
      },
      {
        code: 'ADM',
        group: 'Administration',
        name: 'RightCare Admin',
      },
      {
        code: 'MAN',
        group: 'Administration',
        name: 'RightCare Manager',
      },
    ],
    image: '',
    is_admin: true,
    is_owner: false,
    language: 'fr',
    lastname: 'Adankon',
    phone: '83747773636363',
    rights_codes: ['USA', 'ADM', 'MAN'],
    sexe: 'M',
    status: 1,
    timezone: 'GMT + 1',
    user_id: 'f5f24cd0-ff1a-11e8-9f81-a3a55915c277',
  },
  {
    address: '',
    city: '',
    country: '',
    email: 'frazer@right-com.com',
    firstname: 'Frazer',
    full_rights: [
      {
        code: 'USA',
        group: 'Simple User',
        name: 'RightCare Simple User',
      },
      {
        code: 'ADM',
        group: 'Administration',
        name: 'RightCare Admin',
      },
      {
        code: 'MAN',
        group: 'Administration',
        name: 'RightCare Manager',
      },
    ],
    image: '',
    is_admin: true,
    is_owner: false,
    language: 'fr',
    lastname: 'ALLADASSI',
    phone: '',
    rights_codes: ['USA', 'ADM', 'MAN'],
    sexe: 'M',
    status: 1,
    timezone: '',
    user_id: '8b1bc860-f4e6-11e9-b15a-cf56a17c83d4',
  },
  {
    address: '',
    city: '',
    country: 'BJ',
    email: 'mariama@right-com.com',
    firstname: 'Mariama',
    full_rights: [
      {
        code: 'USA',
        group: 'Simple User',
        name: 'RightCare Simple User',
      },
    ],
    image: '',
    is_admin: true,
    is_owner: false,
    language: 'fr',
    lastname: 'HAROUNA',
    phone: '96291326',
    rights_codes: ['USA'],
    sexe: 'M',
    status: 1,
    timezone: 'GMT+01:00',
    user_id: '40f925f0-ff1b-11e8-9f81-a3a55915c277',
  },
  {
    address: 'Cotonou',
    city: 'Cotonou',
    country: 'BJ',
    email: 'eric@botamp.com',
    firstname: 'Eric',
    full_rights: [
      {
        code: 'USA',
        group: 'Simple User',
        name: 'User of App',
      },
      {
        code: 'ADM',
        group: 'Administration',
        name: 'App Admin',
      },
    ],
    image: '',
    is_admin: false,
    is_owner: false,
    language: 'fr',
    lastname: 'DEGBOE',
    phone: '96473413',
    rights_codes: ['USA', 'ADM'],
    sexe: 'M',
    status: 1,
    timezone: 'GMT+01:00',
    user_id: '22784d50-7d3c-11e9-864b-958cc1d6be60',
  },
  {
    address: '',
    city: '',
    country: 'BJ',
    email: 'adetoye@right-com.com',
    firstname: 'Adetoye',
    full_rights: [
      {
        code: 'USA',
        group: 'Simple User',
        name: 'RightCare Simple User',
      },
      {
        code: 'MAN',
        group: 'Administration',
        name: 'RightCare Manager',
      },
    ],
    image: '',
    is_admin: true,
    is_owner: false,
    language: 'fr',
    lastname: 'Aguessy',
    phone: '+22995951612',
    rights_codes: ['USA', 'MAN'],
    sexe: 'M',
    status: 1,
    timezone: 'GMT + 1',
    user_id: 'df949790-ff1a-11e8-9f81-a3a55915c277',
  },
];

export default FakeAgents;
